import Box from '@mui/material/Box';
import React from 'react';

import { BottomColumn } from '~components/Order/ordersDispatchColumns';
import OrderStatusChip from '~components/Order/OrderStatusChip';
import OrderCard from '~components/OrderCard/OrderCard';
import OrderCardSubtitle from '~components/OrderCard/OrderCardSubtitle';
import OrderCardTitle from '~components/OrderCard/OrderCardTitle';
import { Order } from '~hooks/useOrders/models';

interface FilesOrderProps {
  order: Order;
}

export default function FilesOrder({ order }: FilesOrderProps) {
  return (
    <OrderCard sx={{ borderRadius: 0, boxShadow: 'none', borderBottom: 'none' }}>
      <Box
        sx={{
          alignItems: 'flex-start',
          display: 'grid',
          gap: 1,
          gridTemplateColumns: '1fr auto',
          p: 1,
        }}
      >
        <Box
          sx={{ display: 'flex', flexDirection: 'column', gap: 1, overflow: 'hidden' }}
        >
          <OrderCardTitle order={order} />
          <OrderCardSubtitle order={order} />
        </Box>

        <OrderStatusChip order={order} hideDropdownArrow />

        <Box
          sx={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            gap: 0.5,
            gridColumn: '1 / 3',
            overflow: 'hidden',
          }}
        >
          <BottomColumn omitWrapper order={order} statsSlot={<React.Fragment />} />
        </Box>
      </Box>
    </OrderCard>
  );
}
